<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">


      <material-card

        :title="$t('users.edit.title')"
        :text="$t('users.edit.text')"
      >
        <v-form @submit.prevent="editUser">
          <v-container >
            <v-row>


              <v-col cols="12" md="6">
                <v-text-field
                  v-model="firstName"
                  :error-messages="firstNameErrors"
                  :label="$t('user.firstName')"
                  @input="$v.firstName.$touch()"
                  @blur="$v.firstName.$touch()"

                />

              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="lastName"
                  :error-messages="lastNameErrors"
                  :label="$t('user.lastName')"
                  @input="$v.lastName.$touch()"
                  @blur="$v.lastName.$touch()"

                />

              </v-col>


              <v-col cols="12" md="6">
                <v-text-field
                  v-model="email"
                  :error-messages="emailErrors"
                  :label="$t('user.email')"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                />

              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="username"
                  :error-messages="usernameErrors"
                  :label="$t('user.username')"

                />

              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="password"
                  type="password"
                  :error-messages="passwordErrors"
                  :label="$t('user.password')"

                />

              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="confirmPassword"
                  type="password"
                  :label="$t('user.confirmPassword')"
                  :error-messages="confirmPasswordErrors"
                  @blur="$v.confirmPassword.$touch()"

                />

              </v-col>
              <v-col cols="12" md="6">

                <v-select
                  v-model="role"
                  :items="roles"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('user.role')"
                ></v-select>
              </v-col>
              <v-col v-if="currentUserDepartmentName==''" cols="12" md="6">
                <v-select
                  clearable
                  v-model="department"
                  :items="departments"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('user.department')"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn   @click.prevent="historyBack">
                  {{$t("global.cancel")}}
                </v-btn>&nbsp;
                <v-btn :loading="loading"  @click="submit" color="success">
                  {{$t("global.save")}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import { required, maxLength , email, sameAs} from 'vuelidate/lib/validators'


    export default {
        data() {
            return {
                firstName: "",
                lastName: "",
                email:"",
                username:"",
                originalUsername: "",
                password: "",
                confirmPassword: "",
                department:"",
                role:"",
                roles: [],
                departments:  [],
                loading:false
            }
        },
        validations: {
            firstName: {
                required,
                maxLength:maxLength(255)
            },
            lastName: {
                required,
                maxLength:maxLength(255)
            },
            username: {
                required,
                maxLength:maxLength(255),
                isUnique(value) {
                    if (value === '') return true
                    if (value == this.originalUsername) return true;

                    // simulate async call, fail for all logins with even length
                    return new Promise((resolve, reject) => {
                        api.isUserNameUnique(value).then(response => {
                            resolve(response.unique)
                        })

                    })
                }
            },
            email: {
                required,
                email,
                maxLength:maxLength(255)
            },
            password: {

            },
            confirmPassword: {
                sameAsPassword: sameAs('password')
            }
        },
        methods: {
            submit () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.editUser()

                }
            },
            editUser() {
                this.loading = true
                api.editUser(this.id,this.firstName, this.lastName,this.email, this.username, this.password, this.role, this.department).then(response => {
                    this.$router.push("/users")
                    //   console.log(response.data)
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })

            },
            getUser (userId) {
                 api.getUser(userId).then(response => {
                     this.id = response.id
                    this.firstName= response.firstName
                    this.lastName = response.lastName
                     this.email = response.email
                     this.username = response.username
                     this.originalUsername = response.username
                     this.role=response.role
                      this.department = response.department
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
          getDepartments() {
            api.getDepartments().then(response => {
              this.departments = response
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })
          },

        },
        computed: {
            firstNameErrors () {
                const errors = []
                if (!this.$v.firstName.$dirty) return errors
                !this.$v.firstName.maxLength && errors.push(this.$t('validation.maxLength', [this.$t('user.firstName'), 255]))
                !this.$v.firstName.required && errors.push(this.$t('validation.required', [this.$t('user.firstName')]))
                return errors
            },
            lastNameErrors () {
                const errors = []
                if (!this.$v.lastName.$dirty) return errors
                !this.$v.lastName.maxLength && errors.push(this.$t('validation.maxLength', [this.$t('user.lastName'), 255]))
                !this.$v.lastName.required && errors.push(this.$t('validation.required', [this.$t('user.lastName')]))
                return errors
            },
            usernameErrors () {
                const errors = []
                if (!this.$v.username.$dirty) return errors
                !this.$v.username.maxLength && errors.push(this.$t('validation.maxLength', [this.$t('user.username'), 255]))
                !this.$v.username.required && errors.push(this.$t('validation.required', [this.$t('user.username')]))
                !this.$v.username.isUnique && errors.push(this.$t('validation.user.usernameUnique'))

                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push(this.$t('validation.user.email'))
                !this.$v.email.required && errors.push(this.$t('validation.required', [this.$t('user.email')]))
                return errors
            },
            passwordErrors () {
                const errors = []
                if (!this.$v.password.$dirty) return errors
                return errors
            },
            confirmPasswordErrors () {
                const errors = []
                if (!this.$v.confirmPassword.$dirty) return errors
                !this.$v.confirmPassword.sameAsPassword && errors.push(this.$t('validation.user.passwordIdentical'))

                return errors
            },

        },
        mounted() {
          this.getDepartments()
            this.roles= [
                {'id': "ADMIN", 'name':this.$i18n.t('role.ADMIN')},
                {'id': "PROJECT_PLANNER", 'name':this.$i18n.t('role.PROJECT_PLANNER')},
                {'id': "USER", 'name':this.$i18n.t('role.USER')}
                ]
            if (this.userHasAuthority('MANAGE_CUSTOMERS')) {
                this.roles.push(  {'id': "SYSTEM_ADMIN", 'name':this.$i18n.t('role.SYSTEM_ADMIN')})
            }
            this.getUser(this.$route.params.id);
        }
    }
</script>
